<template>
  <div :class="[rootClass, 'form-check', type === 'switch' && 'form-switch']">
    <input :id="id" class="form-check-input" type="checkbox" :value="value" :checked="checked" @input="emitInput">
    <label :class="[`checkbox-field__label`, 'form-check-label']" :for="id">
      <slot name="label">{{ label }}</slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'check'
    },
    value: {
      type: [Boolean, Number, String],
      default: false
    },
    // El estado marcado, aparte de `value`, que en los extras es el id de la fila.
    // Sin esto la casilla no la pintaba Vue sino el navegador, asi que al recargar o
    // al volver atras se restauraba marcada con el estado del formulario en blanco.
    checked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rootClass: 'checkbox-field'
    }
  },
  methods: {
    emitInput(ev) {
      this.$emit('input', { name: this.name, value: ev.target.value, selected: ev.target.checked })
    }
  }
}
</script>
